import React from "react";
import Helmet from "react-helmet";
import LegalLinks from "components/v3/legal-links/LegalLinks";
import PropTypes from "prop-types";

class VerifyBulkSubscription extends React.Component {
    _resendConfirmationEmail(event) {
        const {
            email,
            resetPassword
        } = this.props.location.query;

        event.preventDefault();
        this.props.clearConfirmationEmailMessage();
        this.props.resendBulkSubscriptionConfirmationEmail(email, resetPassword);
    }

    _message() {
        if (this.props.resendConfirmationEmailSuccessMessage) {
            return (
                <div className="account__email-not-confirmed--success" ref="resendEmailSuccess">
                    { this.props.resendConfirmationEmailSuccessMessage }
                </div>
            );
        }

        if (this.props.resendConfirmationEmailErrorMessage) {
            return (
                <div className="account__email-not-confirmed--error" ref="resendEmailError">
                    { this.props.resendConfirmationEmailErrorMessage }
                </div>
            );
        }
    }

    render() {
        return (
            <div className="container verification-expired" data-v2="true">
                <Helmet title={ `${ this.props.titleText } - Bloomberg` } />

                <h1 className="signup-signin__title">{ this.props.titleText }</h1>
                <h2 className="signup-signin__subtitle">{ this.props.subTitleText }</h2>

                <a
                    href="/#"
                    className="account__email-resend-confirmation"
                    onClick={ this._resendConfirmationEmail.bind(this) }
                    ref="resendConfirmation"
                >
                    Re-send confirmation
                </a>
                This link will expire after 24 hours.

                { this._message() }

                <LegalLinks bloombergSiteUrl={ this.props.bloombergSiteUrl } />
            </div>
        );
    }
}

VerifyBulkSubscription.propTypes = {
    resendBulkSubscriptionConfirmationEmail: PropTypes.func.isRequired,
    clearConfirmationEmailMessage: PropTypes.func.isRequired,
    titleText: PropTypes.string.isRequired,
    subTitleText: PropTypes.string.isRequired,
    bloombergSiteUrl: PropTypes.string.isRequired
};

export default VerifyBulkSubscription;
